// Will only render the `content` or `render` elements if the tippy is mounted to the DOM.
// Replace <Tippy /> with <LazyTippy /> component and it should work the same.

import React from "react"

import Tippy, { TippyProps } from "@tippyjs/react"

const LazyTippy = (props: TippyProps) => {
  return props.visible ? <Tippy {...props} /> : null
}

export default LazyTippy
